import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "donation-form-heading" }
const _hoisted_2 = { id: "donation-form-subheading" }
const _hoisted_3 = {
  key: 1,
  class: "show-summary-and-payment-type flow"
}

import Payment from '@src/components/pages/donation_form/Payment/Payment.vue';
import { nextTick, ref } from 'vue';
import PaymentSummary from '@src/components/pages/donation_form/Summaries/PaymentSummary.vue';
import { useStore } from 'vuex';
import { usePaymentFunctions } from '@src/components/pages/donation_form/composables/usePaymentFunctions';
import { Validity } from '@src/view_models/Validity';
import ContentCard from '@src/components/patterns/ContentCard.vue';
import IbanFields from '@src/components/pages/donation_form/Payment/IbanFields.vue';
import { useAmountFocuser } from '@src/components/shared/composables/useAmountFocuser';

enum FormStates {
	showEntireForm = 'showEntireForm',
	showSummary = 'showSummary',
	showSummaryAndPaymentType = 'showSummaryAndPaymentType',
}

interface Props {
	paymentAmounts: number[];
	paymentIntervals: number[];
	paymentTypes: string[];
	isDirectDebitPayment: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentSection',
  props: {
    paymentAmounts: {},
    paymentIntervals: {},
    paymentTypes: {},
    isDirectDebitPayment: { type: Boolean }
  },
  setup(__props: any) {


const store = useStore();
const focusAmount = useAmountFocuser( useStore() );

const initialFormState = (): FormStates => {
	if ( store.state.payment.validity.type === Validity.VALID && store.state.payment.validity.amount === Validity.VALID ) {
		return FormStates.showSummary;
	} else if ( store.state.payment.validity.amount === Validity.VALID ) {
		return FormStates.showSummaryAndPaymentType;
	} else {
		return FormStates.showEntireForm;
	}
};

const state = ref<FormStates>( initialFormState() );

const { paymentSummary } = usePaymentFunctions( store );

const showPaymentForm = async () => {
	state.value = FormStates.showEntireForm;
	await nextTick();
	focusAmount();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContentCard, null, {
    heading: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t( 'donation_form_heading' )), 1),
      _createElementVNode("h2", _hoisted_2, "1. " + _toDisplayString(_ctx.$t( 'compact_donation_form_payment_heading' )), 1)
    ]),
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "error-summary"),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t( 'compact_donation_form_payment_blurb' )), 1),
      (state.value === FormStates.showSummary)
        ? (_openBlock(), _createBlock(PaymentSummary, {
            key: 0,
            onShowPaymentForm: showPaymentForm,
            amount: _unref(paymentSummary).amount,
            interval: _unref(paymentSummary).interval,
            "payment-type": _unref(paymentSummary).paymentType
          }, null, 8, ["amount", "interval", "payment-type"]))
        : _createCommentVNode("", true),
      (state.value === FormStates.showSummaryAndPaymentType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(PaymentSummary, {
              onShowPaymentForm: showPaymentForm,
              amount: _unref(paymentSummary).amount,
              interval: _unref(paymentSummary).interval,
              "payment-type": _unref(paymentSummary).paymentType
            }, null, 8, ["amount", "interval", "payment-type"]),
            _createVNode(Payment, {
              "payment-amounts": __props.paymentAmounts,
              "payment-intervals": __props.paymentIntervals,
              "payment-types": __props.paymentTypes,
              "display-sections": [ 'paymentType' ]
            }, null, 8, ["payment-amounts", "payment-intervals", "payment-types"])
          ]))
        : _createCommentVNode("", true),
      (state.value === FormStates.showEntireForm)
        ? (_openBlock(), _createElementBlock("form", {
            key: 2,
            name: "laika-donation-payment",
            class: "flow compact",
            ref: "paymentForm",
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode(Payment, {
              "payment-amounts": __props.paymentAmounts,
              "payment-intervals": __props.paymentIntervals,
              "payment-types": __props.paymentTypes
            }, null, 8, ["payment-amounts", "payment-intervals", "payment-types"])
          ], 544))
        : _createCommentVNode("", true),
      (__props.isDirectDebitPayment)
        ? (_openBlock(), _createBlock(IbanFields, { key: 3 }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})